import { PAIN_POINTS } from "../data/automationData";

export const BeforeAfter = ({ painIds }) => {
  const pains = PAIN_POINTS.filter((p) => painIds.includes(p.id));
  const maxMin = Math.max(...pains.map((p) => p.manualMinutes), 1);

  return (
    <div className="bg-card border border-border rounded-2xl p-6 md:p-8 shadow-sm">
      <h3 className="font-heading text-xl font-semibold mb-1">Antes vs. Después</h3>
      <p className="text-sm text-muted-foreground mb-8">
        Cuánto tiempo consume cada tarea al día — a mano vs. con la IA ayudándote.
      </p>

      <div className="space-y-8">
        {pains.map((p) => (
          <div key={p.id} data-testid={`before-after-${p.id}`}>
            <div className="flex items-center justify-between mb-3">
              <span className="font-medium">{p.label}</span>
              <span className="text-sm font-semibold text-emerald-700">
                {p.manualMinutes - p.aiMinutes} min ahorrados/día
              </span>
            </div>

            <div className="mb-2">
              <div className="flex justify-between text-xs text-muted-foreground mb-1">
                <span>A mano</span>
                <span>{p.manualMinutes} min</span>
              </div>
              <div className="h-4 rounded-full bg-secondary overflow-hidden">
                <div
                  className="h-full rounded-full bg-muted-foreground/50 transition-all duration-700"
                  style={{ width: `${(p.manualMinutes / maxMin) * 100}%` }}
                />
              </div>
            </div>

            <div>
              <div className="flex justify-between text-xs text-muted-foreground mb-1">
                <span>Con IA</span>
                <span>{p.aiMinutes} min</span>
              </div>
              <div className="h-4 rounded-full bg-secondary overflow-hidden">
                <div
                  className="h-full rounded-full bg-accent transition-all duration-700"
                  style={{ width: `${(p.aiMinutes / maxMin) * 100}%` }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
